<template>
  <v-dialog :value="isActive" persistent max-width="800" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="font-weight-medium primary--text">
          {{ isEditMode ? "Actualizar" : "Crear" }} enlace de formulario
        </v-card-title>

        <v-divider></v-divider>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 500px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="mt-4 py-0">
                <ValidationProvider
                  name="nombre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                    :disabled="isEditMode"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- URL -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="URL" rules="" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="URL"
                      name="URL"
                      prepend-inner-icon="mdi-web"
                      color="blue-grey"
                      v-model="payload.url"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="pb-0">
                  <v-select
                    v-model="payload.type"
                    prepend-inner-icon="mdi-bell"
                    required
                    filled
                    rounded
                    dense
                    class="rounded-small"
                    item-text="name"
                    item-value="id"
                    :items="typeList"
                    label="Tipo"
                    hint="Interno: El enlace se abre en PBXBerry. Externo: Se abre en una pestaña nueva."
                  ></v-select>
              </v-col>

              <!-- Descripción -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="descripción"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.description"
                    :error-messages="errors"
                    label="Descripción"
                    rounded
                    filled
                    dense
                    class="rounded-small"
                    :disabled="isEditMode"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  components: {
    vuescroll,
  },

  data() {
    return {
      // isLoadingClients: true,
      isLoading: false,
      // externalClientList: [],
      typeList: [
        {
          id: 0,
          name: "Interno"
        },
        {
          id: 1,
          name: "Externo"
        },
      ],
      payload: {
        name: "",
        url: "",
        type: 1,
        description: "",
      },
    };
  },

  // computed: {
  //   Clients() {
  //     return this.$store.getters["clients/GET_ALL_CLIENTS"];
  //   },
  // },

  created() {
    // this.getCampaigns();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.url = "";
      this.payload.type = null;
      this.payload.description = "";
    },

    // async GetClients() {
    //   try {
    //     const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
    //     this.data = response.data;
    //     this.isLoadingClients = false;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    // async getCampaigns() {
    //   try {
    //     const { data } = await PbxHttpClient.get(
    //       `/campaign/campaign_select/${this.idQueue}`
    //     );
    //     this.typeList = data;
    //   } catch (err) {
    //     console.log("error getting campaign", err);
    //   }
    // },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async submitForm() {
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(
              `/external/external_links/${id}`,
              payload
            )
          : await PbxHttpClient.post(
              "/external/external_links",
              payload
            );
        this.closeDialog(data);

        this.$snotify.success("Configuración creada con éxito.", "¡Hecho!");
      } catch (err) {
        this.isLoading = false;
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
